// Plan settings strings — EN + TR.
//
// Wave-2 Day 1. Subscription tier card layout (sellers only). Volkan
// direction 2026-05-23 (Settings 10-section expansion item #3).
//
// Tier names (Free / Starter / Pro) preserved as proper nouns in both
// locales — pricing tier model 4-tier ratify (internal/partner/reseller/b2b)
// orthogonal to subscription tier; canonical EN brand name pattern.
//
// Source: features/settings/Plan.tsx.

import type { LocalizedDict } from '../index'

type PlanStrings = {
  pageTitle: string
  pageDescription: string
  footerNote: string
  toastTail: string
  currentBadge: string
  currentPlan: string
  switchTo: (tier: string) => string
  period: string
  tiers: {
    free: {
      label: string
      description: string
      features: string[]
    }
    starter: {
      label: string
      description: string
      features: string[]
    }
    pro: {
      label: string
      description: string
      features: string[]
    }
  }
}

export const planI18n: LocalizedDict<PlanStrings> = {
  en: {
    pageTitle: 'Plan',
    pageDescription:
      'Pick the tier that matches your operations volume. Pricing is illustrative; final billing model is M3 prerequisite.',
    footerNote:
      'Placeholder section · backend binding pending M3 Stage 4 SPEC.md Faz 4 ratification.',
    toastTail:
      'Subscription billing ratifies M3 Stage 4 SPEC.md Faz 4 (Wallets + Settlement).',
    currentBadge: 'Current',
    currentPlan: 'Current plan',
    switchTo: (tier) => `Switch to ${tier}`,
    period: '/ month',
    tiers: {
      free: {
        label: 'Free',
        description: 'Get started with PEXIFY core operations.',
        features: [
          'Up to 1 store',
          'Manual order routing',
          'Standard shipping rates',
          'Community support',
        ],
      },
      starter: {
        label: 'Starter',
        description: 'Multi-store coordination + discounted labels.',
        features: [
          'Up to 3 stores',
          'Bulk label printing',
          'Tag-driven batch workflows',
          'Email support',
        ],
      },
      pro: {
        label: 'Pro',
        description:
          'Full team + vendor coordination + wallet automation.',
        features: [
          'Unlimited stores',
          'Vendor + production partner routing',
          'Wallet automation + referral payouts',
          'Priority support',
        ],
      },
    },
  },
  tr: {
    pageTitle: 'Plan',
    pageDescription:
      'Operasyon hacmine uyan paketi seç. Fiyatlandırma temsilidir; nihai faturalama modeli M3 ön koşulu.',
    footerNote:
      'Yer tutucu bölüm · backend bağlama M3 Stage 4 SPEC.md Faz 4 ratify ile gelir.',
    toastTail:
      'Abonelik faturalama M3 Stage 4 SPEC.md Faz 4 (Cüzdan + Settlement) ile ratify.',
    currentBadge: 'Mevcut',
    currentPlan: 'Mevcut plan',
    switchTo: (tier) => `${tier} paketine geç`,
    period: '/ ay',
    tiers: {
      free: {
        label: 'Free',
        description: 'PEXIFY temel operasyonlarıyla başla.',
        features: [
          '1 mağazaya kadar',
          'Manuel sipariş yönlendirme',
          'Standart kargo fiyatları',
          'Topluluk desteği',
        ],
      },
      starter: {
        label: 'Starter',
        description: 'Çoklu mağaza koordinasyonu + indirimli etiketler.',
        features: [
          '3 mağazaya kadar',
          'Toplu etiket yazdırma',
          'Etiket tabanlı toplu iş akışları',
          'E-posta desteği',
        ],
      },
      pro: {
        label: 'Pro',
        description:
          'Tam ekip + tedarikçi koordinasyonu + cüzdan otomasyonu.',
        features: [
          'Sınırsız mağaza',
          'Tedarikçi + üretim ortağı yönlendirme',
          'Cüzdan otomasyonu + referans ödemeleri',
          'Öncelikli destek',
        ],
      },
    },
  },
}
